import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import './RefreshStatus.css';

export default class RefreshStatus extends Component {
  getSpinnerElement() {
    if (this.props.isLoading) {
      return <FontAwesomeIcon icon="circle-notch" spin className="refresh-icon" />;
    }

    return null;
  }

  getFailureElement() {
    if (this.props.error) {
      return <FontAwesomeIcon icon="plug" className="refresh-icon" />;
    }

    return null;
  }

  getLastLoadTimeElement() {
    // Show to user only if data is stale
    const isLastLoadTimeVisible = this.props.lastLoadTime instanceof moment &&
      this.props.lastLoadTime.isBefore(moment().subtract(2, 'minutes'));

    if (isLastLoadTimeVisible) {
      return this.props.lastLoadTime.fromNow();
    }

    return null;
  }

  render() {
    return (
      <div className={`RefreshStatus ${this.props.className}`}>
        {this.getSpinnerElement()}
        {this.getFailureElement()}
        {this.getLastLoadTimeElement()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RefreshStatus/RefreshStatus.js